import { useQuery } from '@tanstack/react-query'
import { useRecoilValue } from 'recoil'

import { useNodeApi } from '../api-provider'
import { selectedRoleState } from '../state'

const QUERY_KEY = 'getVendiaTable'

export function useGetVendiaTable(tableId: string) {
  const nodeApi = useNodeApi()
  const { urqlClient } = nodeApi

  const selectedRoleName = useRecoilValue(selectedRoleState).name

  return useQuery({
    queryKey: [QUERY_KEY, selectedRoleName, tableId],
    queryFn: async () => {
      if (!urqlClient) {
        throw new Error('Node API client is not available')
      }
      const result = await urqlClient.query(getVendiaTableQuery, { id: tableId }).toPromise()
      if (result?.error) {
        throw new Error(result.error?.message)
      }
      return result.data.getVendia_Table
    },
    enabled: !!selectedRoleName && !!tableId,
  })
}

const getVendiaTableQuery = /* GraphQL */ `
  query getVendiaTable($id: ID!) {
    getVendia_Table(id: $id) {
      _acl {
        operations
        path
        principal {
          nodes
        }
      }
      _id
      _owner
      columns {
        comment
        fieldId
        fieldType
        identifier
        name
        required
      }
      defaultShareWith
      name
      nodeTableName
      policies {
        columnPolicies {
          effect
          name
          operator
          value
        }
        defaultColumnPolicyEffect
        rowPolicies {
          effect
          name
          operator
          value
        }
      }
      source {
        definition {
          cloudera {
            connectionId
            keyColumns
            lastUpdatedColumn
            lastUpdatedColumnFormat
            tableName
          }
          mysql {
            connectionId
            keyColumns
            lastUpdatedColumn
            lastUpdatedColumnFormat
            tableName
          }
          postgres {
            connectionId
            keyColumns
            lastUpdatedColumn
            lastUpdatedColumnFormat
            tableName
          }
          bigquery {
            connectionId
            keyColumns
            lastUpdatedColumn
            lastUpdatedColumnFormat
            tableName
          }
          s3 {
            connectionId
            csvColumns
            csvOptions {
              dateFormat
              delimiter
              enclosure
              errorHandling
              header
              timeFormat
              timestampFormat
              whitespace
            }
            fileName
          }
          snowflake {
            connectionId
            keyColumns
            lastUpdatedColumn
            lastUpdatedColumnFormat
            tableName
          }
          upload {
            csvColumns
            csvOptions {
              dateFormat
              delimiter
              enclosure
              errorHandling
              header
              timeFormat
              timestampFormat
              whitespace
            }
            fileName
          }
          vendia {
            joinQuery
            keyColumns
            lastUpdatedColumn
            lastUpdatedColumnFormat
            tableName
          }
        }
        mapping {
          fieldId
          icebergFieldId
        }
      }
      status
    }
  }
`
